import { clsx } from "clsx";
import { memo } from "react";
import "./HighlightedText.scss";

interface IHighlightedText {
  text: string;
  highlight: string;
  className?: string;
}

export const HighlightedText: React.FC<IHighlightedText> = memo(({
  text,
  highlight,
  className
}) => {
  const parts = text.split(new RegExp(`(${highlight})`, "gi"));

  return (
    <span className={clsx("highlightedText", className)}>
      {
        parts.map((part, i) => (
          <span key={i} className={clsx(part.toLowerCase() === highlight.toLowerCase() && "activeLetter")}>
            {part}
          </span>)
        )
      }
    </span>
  );
});
